module.exports = __webpack_public_path__ + "img/youtube.7741653e.svg";